import {ImageOpContextImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-imgproc"
import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {createImageOpImgProc} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/imgproc/image-op-imgproc-utils"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/definition"
import {convertToImageProcessingGeometry} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/helpers"
import {ImageProcessingNodes} from "@cm/image-processing-nodes"
import {JobNodes} from "@cm/job-nodes"
import {ImageOpRasterizeGeometryHal} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/rasterize-geometry/hal"
import {ImageOpParametersOfType} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/specializing-image-op-node"
import {ImageOpInputsOrNodes} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {BasicSpecializingImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/basic-specializing-image-op-node"
import {IMGPROC_DEFAULT_INTERPOLATION_MODE} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/utils/imgproc-utils"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeRasterizeGeometry"}

@registerImageOpNode
export class ImageOpNodeRasterizeGeometry extends BasicSpecializingImageOpNode<typeof definition, ImageOpRasterizeGeometryHal> {
    override get definition() {
        return nodeDefinition
    }

    constructor(parameters: ImageOpInputsOrNodes<typeof definition>) {
        super(ImageOpRasterizeGeometryHal, parameters)
    }

    override toImgProc = async (evaluator: Evaluator<ImageOpContextImgProc>, parameters: ImageOpParametersOfType<typeof definition, "imgproc">) => {
        const evaluatedParameters = await evaluator.getAll(parameters)
        if (evaluatedParameters.addressMode !== "wrap") {
            // throw new Error("Only wrap address mode is supported in ImgProc")
            ImageOpNodeRasterizeGeometry.logger?.warn("Only wrap address mode is supported in ImgProc; using 'wrap' instead.")
        }
        let imgProcGeometry: ImageProcessingNodes.GeometryNode
        if (JobNodes.isDataObjectReference(evaluatedParameters.geometry)) {
            imgProcGeometry = ImageProcessingNodes.externalData(evaluatedParameters.geometry, "geometry")
        } else {
            imgProcGeometry = convertToImageProcessingGeometry(evaluatedParameters.geometry)
        }
        const resultImage = evaluator.context.createEmptyImage(evaluatedParameters.descriptor)
        return createImageOpImgProc(resultImage.descriptor, {
            type: "rasterizeGeometry",
            geometry: imgProcGeometry,
            texture: evaluatedParameters.textureImage?.node,
            interpolationMode: IMGPROC_DEFAULT_INTERPOLATION_MODE,
            target: resultImage.node,
        })
    }
}
